import { render, staticRenderFns } from "./SliderItems.vue?vue&type=template&id=4896fc76&scoped=true&"
import script from "./SliderItems.vue?vue&type=script&lang=js&"
export * from "./SliderItems.vue?vue&type=script&lang=js&"
import style0 from "./SliderItems.vue?vue&type=style&index=0&id=4896fc76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4896fc76",
  null
  
)

export default component.exports